import type { CityConfig } from "@/pages/city-template/types";

export const watertownConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Watertown",
  state: "New York",
  stateAbbr: "NY",
  slug: "watertown",
  route: "/cities/watertown",
  title: "Emergency Passport Watertown, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Watertown, NY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Fort Drum military families, Thousand Islands tourism, and all Jefferson County travelers.",
  h1: "Emergency & Expedited Passport Services in Watertown, NY",
  heroSubtitle: "Fort Drum soldier deploying to Germany on 7 days' notice? Thousand Islands cruise crossing into Canada? SUNY Jefferson student studying abroad in London? We help Watertown residents — from Fort Drum military families to Carthage locals to Sackets Harbor waterfront homeowners — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Panoramic%20view%20of%20Watertown%20New%20York%20downtown%20with%20historic%20Public%20Square%20and%20Black%20River%2C%20Thousand%20Islands%20region%20visible%20in%20the%20distance%20with%20St%20Lawrence%20River%2C%20Fort%20Drum%20in%20the%20background%2C%20green%20summer%20landscape%20with%20dramatic%20clouds%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20warm%20golden%20hour%20light%2C%20no%20text%20overlay%2C%20upstate%20New%20York%20North%20Country%20cityscape%20with%20river%20and%20historic%20architecture&width=1800&height=700&seq=watertown-hero-2026&orientation=landscape",
  heroImageAlt: "Watertown New York downtown with Public Square and Black River at golden hour",
  geoPosition: "43.9748; -75.9108",
  geoPlacename: "Watertown, New York",
  lastModified: "2026-06-10",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~280 miles (Southeast in Manhattan)",
  },
  nearbyCitiesZips: [
    { name: "Watertown", zips: "13601, 13602, 13603" },
    { name: "Fort Drum", zips: "13602, 13603" },
    { name: "Carthage", zips: "13619" },
    { name: "Adams", zips: "13605, 13606" },
    { name: "Sackets Harbor", zips: "13685" },
    { name: "Copenhagen", zips: "13626" },
    { name: "Canton", zips: "13617" },
    { name: "Potsdam", zips: "13676, 13699" },
    { name: "Ogdensburg", zips: "13669" },
    { name: "Syracuse", zips: "13201-13210, 13211, 13212, 13214, 13215, 13217, 13218, 13219, 13220, 13224, 13225, 13235, 13244, 13250, 13251, 13252, 13261, 13290" },
    { name: "Rome", zips: "13440, 13441, 13442, 13449" },
    { name: "Utica", zips: "13501, 13502, 13503, 13504, 13505, 13599" },
    { name: "Albany", zips: "12201-12212, 12214, 12220, 12222-12226, 12228, 12230-12232, 12233, 12234, 12235, 12236, 12237, 12238, 12239, 12240, 12241, 12242, 12243, 12244, 12245, 12246, 12247, 12248, 12249, 12250, 12252, 12255, 12256, 12257, 12260, 12261, 12262, 12288" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Emergency Processing", desc: "Reserved courier access to the New York Passport Agency — as fast as 24 hours for Fort Drum military families and Watertown travelers with immediate departures." },
    { icon: "ri-shield-user-line", title: "Fort Drum Military Ready", desc: "10th Mountain Division PCS deployments, TDY assignments, family emergency leave — we understand military timelines and the urgency of sudden overseas orders." },
    { icon: "ri-anchor-line", title: "Thousand Islands & Border Travel", desc: "Cross-border Canada trips, St. Lawrence River cruising, Montreal escapes — Watertown is 30 miles from the Canadian border and Passport Cards are essential here." },
    { icon: "ri-graduation-cap-line", title: "SUNY & College Expedited", desc: "SUNY Jefferson, SUNY Potsdam, Clarkson, St. Lawrence University students studying abroad — we guide first-time applicants through the acceptance process." },
  ],
  internalLinks: [
    { name: "Fast passport services in Syracuse, NY", route: "/cities/syracuse" },
    { name: "Expedited passport in Albany, NY", route: "/cities/albany-ny" },
    { name: "Quick passport services in Plattsburgh, NY", route: "/cities/plattsburgh" },
    { name: "Urgent passport services in Ogdensburg, NY", route: "/cities/ogdensburg" },
    { name: "New York passport services overview", route: "/newyork" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote: "Fast Passport Center serves Watertown via secure registered courier with direct access to the New York Passport Agency at 376 Hudson Street. Our registered couriers hand-deliver your documents — meaning you get faster results without the 280-mile drive to Manhattan. Watertown residents can ship from any UPS Store, FedEx Office, or post office location across Jefferson County.",
  fpcOfficeDistance: "Serving Watertown, Fort Drum, Carthage, and all Jefferson County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Watertown and the greater Jefferson County region. From the historic Public Square to the Fort Drum cantonment area, from Carthage to Sackets Harbor — we serve all of the North Country. Our courier service eliminates the need to drive 280 miles to Manhattan and wait for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Watertown and all Jefferson County communities including Fort Drum, Carthage, Adams, Sackets Harbor, and Copenhagen. We also serve travelers departing from Watertown International Airport (ART) and Syracuse Hancock International who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Watertown as simple as possible — with the efficiency and reliability North Country military families, Thousand Islands travelers, and college students need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Watertown travelers start online and ship documents overnight — no office visit required.",
  mistakesIntro: "Watertown travelers encounter unique passport issues — everything from military deployment timelines to 6-month validity rules for Asian destinations to cross-border Canada travel requirements. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Watertown travelers — from Fort Drum military families to Carthage locals to Sackets Harbor residents — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Watertown, NY? Here are the most common ones we hear from North Country travelers.",
  statePageRoute: "/newyork",
  statePageName: "New York",
  servicesIntro: "Whether you need a renewal before a Fort Drum deployment, an emergency passport for a sudden overseas assignment, or a first-time passport for a Thousand Islands cruise into Canada — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Fort Drum deployment to Germany next week? Family emergency overseas? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Watertown-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Watertown residents renew fast — no agency visit required for most renewals. Perfect for Fort Drum families preparing for overseas PCS moves and Thousand Islands border crossers.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Watertown residents through every step — from Fort Drum to Carthage to Sackets Harbor — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your deployment or family emergency trip to Germany is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your military family PCS move or North Country family trip abroad stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Fort Drum military spouses after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Fort Drum personnel deploying while their primary passport is in visa processing, and college faculty traveling internationally.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide North Country travelers through the process so your deployment or international itinerary stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Essential for Watertown residents making weekend trips to Montreal or Thousand Islands day cruises into Canadian waters.",
      bullets: ["Wallet-size convenience", "Land and sea travel to Canada", "Same expedited processing"],
      badge: "Border Essential",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Watertown NY", description: "Urgent passport processing for Watertown New York travelers with immediate departure needs including Fort Drum military deployments." },
    { name: "Expedited Passport Renewal Watertown NY", description: "Fast passport renewal for Watertown New York residents with a previously-issued passport." },
    { name: "First-Time Passport Watertown NY", description: "New passport application services for Watertown New York residents applying for their first passport." },
    { name: "Child Passport Watertown NY", description: "Minor passport services for Watertown New York families with children under 16." },
    { name: "Name Change Passport Watertown NY", description: "Passport name correction after marriage, divorce, or legal name changes for Watertown residents." },
    { name: "Second Passport Watertown NY", description: "Second passport services for Fort Drum military personnel and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Sgt. Michael R.",
      location: "Fort Drum, NY",
      rating: 5,
      text: "Our unit got 7 days' notice for a Germany deployment and my passport was expired. Fast Passport Center got it processed in 3 days. They understand military timelines in a way no other service does.",
      service: "Emergency Passport",
    },
    {
      name: "Lisa W.",
      location: "Watertown, NY",
      rating: 5,
      text: "We do the Thousand Islands cruise into Canada every summer and realized our kids' passports were expired 2 weeks before departure. Fast Passport Center handled all three applications and got them back in 5 days.",
      service: "Child Passport Renewal",
    },
    {
      name: "David C.",
      location: "Carthage, NY",
      rating: 5,
      text: "First-time passport for my SUNY Jefferson study abroad program. The agent walked me through the acceptance clerk process at the Watertown post office. Processed in 5 days with no issues.",
      service: "New Passport",
    },
    {
      name: "Amanda K.",
      location: "Sackets Harbor, NY",
      rating: 5,
      text: "My husband's PCS orders came through and we needed passports for the whole family in under 2 weeks. Fast Passport Center got all four of us processed. The military-specific guidance was invaluable.",
      service: "Family Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "watertown-1",
      name: "Watertown Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "232 Washington Street",
      city: "Watertown",
      state: "NY",
      zip: "13601",
      phone: "(315) 782-6540",
      hours: "Mon–Fri 8:30 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Downtown Watertown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Primary Watertown passport acceptance facility. Passport photos available on-site. Appointment recommended for first-time applicants. Busiest facility in Jefferson County — book early during summer tourism season.",
      icon: "ri-mail-line",
    },
    {
      id: "watertown-2",
      name: "Fort Drum Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11030 Mount Belvedere Boulevard",
      city: "Fort Drum",
      state: "NY",
      zip: "13602",
      phone: "(315) 772-6544",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Fort Drum military installation",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "On-post passport acceptance for military personnel and dependents. ID required for base access. Most convenient for 10th Mountain Division families and active-duty personnel.",
      icon: "ri-shield-line",
    },
    {
      id: "watertown-3",
      name: "Carthage Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "525 State Street",
      city: "Carthage",
      state: "NY",
      zip: "13619",
      phone: "(315) 493-2310",
      hours: "Mon–Fri 9:00 AM – 4:30 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Carthage — southeast of Watertown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serves Carthage, West Carthage, and southern Jefferson County communities. Less crowded than Watertown Main — good alternative during peak tourism months.",
      icon: "ri-mail-line",
    },
    {
      id: "watertown-4",
      name: "Adams Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "45 East Church Street",
      city: "Adams",
      state: "NY",
      zip: "13605",
      phone: "(315) 232-2211",
      hours: "Mon–Fri 9:00 AM – 4:30 PM",
      distance: "Adams — south of Watertown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Convenient for Adams and south Jefferson County residents. Smaller facility with shorter wait times. Call ahead to confirm passport services availability.",
      icon: "ri-mail-line",
    },
    {
      id: "watertown-5",
      name: "SUNY Jefferson — Student Services",
      type: "Campus Passport Guidance",
      address: "1220 Coffeen Street",
      city: "Watertown",
      state: "NY",
      zip: "13601",
      phone: "(315) 786-2200",
      hours: "Mon–Fri 8:00 AM – 4:00 PM (academic year)",
      distance: "Watertown — SUNY Jefferson campus",
      website: "https://www.sunyjefferson.edu/",
      websiteLabel: "SUNY Jefferson",
      notes: "Study abroad office — provides guidance for students needing first-time passports. Not a full passport acceptance facility — students directed to Watertown Post Office for the acceptance clerk visit.",
      icon: "ri-graduation-cap-line",
    },
    {
      id: "watertown-6",
      name: "Sackets Harbor Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "112 Woolsey Street",
      city: "Sackets Harbor",
      state: "NY",
      zip: "13685",
      phone: "(315) 646-3261",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Sackets Harbor — west of Watertown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Smaller facility serving Sackets Harbor and lakefront communities. Call ahead to confirm passport acceptance hours — limited clerk availability.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 280 miles to Manhattan's New York Passport Agency", fpc: "Most North Country travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Military & Border Expertise", agency: "Generic — no Fort Drum deployment or Canada border travel knowledge", fpc: "Full military family, PCS, and cross-border expertise built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Deployment Passports Without Enough Lead Time",
      description: "Fort Drum PCS orders and TDY assignments frequently come with 5–10 day notice. Standard post office processing takes 8–11 weeks — a guaranteed recipe for a missed movement. Our courier channel handles 3–5 day turnaround reliably.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Watertown applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Many Watertown pharmacies and big-box stores produce photos that fail State Department standards — wrong background, wrong sizing, face too small. We catch this in review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Military Families",
      description: "Fort Drum families with a deployed parent frequently overlook the DS-3053 consent form. This is an automatic rejection — we guide you through getting notarized consent from the deployed parent correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Realizing Canada Requires a Passport Now",
      description: "Many Watertown residents remember the days when a driver's license was enough to cross into Canada at the Thousand Islands Bridge. Since 2009, a passport, passport card, or enhanced driver's license is required. We see this mistake constantly.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date or deployment timeline and complete your secure order. Takes just a few minutes from your home, office, or Fort Drum barracks." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your military or civilian travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Watertown clients ship from home — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 280 miles to Manhattan or wait at the New York Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Watertown?", a: "We offer Watertown-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit a Watertown office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (the Watertown Post Office, Fort Drum Post Office, or Carthage Post Office), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Watertown address." },
    { q: "Where can I get a passport acceptance in Watertown?", a: "Watertown has passport acceptance at the Main Post Office on Washington Street, the Fort Drum Post Office on-base for military families, the Carthage Post Office, and the Adams Post Office. We maintain an updated list of Jefferson County facilities with hours and appointment options." },
    { q: "Does the New York Passport Agency handle walk-ins?", a: "The New York Passport Agency (located in Manhattan, 280 miles from Watertown) requires appointments for life-or-death emergency travel only. Walk-ins are rarely accepted. For travel within 3–14 days, our registered courier service is the fastest legally available channel — and you never need to leave Watertown." },
    { q: "What is the best price for expedited passport service in Watertown?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "What documents do Watertown applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Watertown-specific checklist." },
    { q: "Can I get a passport photo in Watertown?", a: "Yes — many Watertown CVS, Walgreens, Rite Aid, and Walmart locations offer passport photos. We recommend confirming photo standards compliance before visiting. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How do I check my Watertown passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Watertown to final return shipping typically matches your chosen speed tier." },
    { q: "Can you help with Fort Drum deployment passport timing?", a: "Yes. We regularly assist Fort Drum soldiers with expedited passports for PCS moves to Germany, Italy, South Korea, and other overseas assignments. We understand the 5–10 day notice windows common with military orders and can handle multiple family members simultaneously." },
    { q: "Do I need a passport to cross into Canada from Watertown?", a: "Yes — since 2009, U.S. citizens need a passport book, passport card, or enhanced driver's license to cross into Canada at the Thousand Islands Bridge (Alexandria Bay) or any other border crossing. A passport card is ideal for Watertown residents who drive to Montreal, Ottawa, or Kingston regularly." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Watertown Residents",
    intro: "Watertown's unique position — a military community 30 miles from the Canadian border and 75 miles from Syracuse — creates distinct passport timing challenges. Here's what North Country travelers need to know.",
    cards: [
      {
        icon: "ri-shield-user-line",
        title: "Fort Drum — 10th Mountain Division Deployments",
        subtitle: "Military PCS orders, TDY assignments, family emergency leave",
        description: "Fort Drum is home to the 10th Mountain Division, one of the Army's most deployed divisions. PCS orders to Germany, Italy, and South Korea come with notoriously short notice windows — sometimes as little as 5–10 days. Family members need passports for accompanied tours, and soldiers often need expedited renewals when they discover expired passports during pre-deployment processing. The volume of military passport needs in Watertown is unlike any other city of its size in the country.",
        tip: "Never wait for PCS orders to arrive before checking your passport. Keep your passport and your family's passports valid at all times — many Fort Drum families learn this lesson the hard way when orders come with a 7-day departure window.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "ART — Watertown International Airport",
        subtitle: "Regional connector to PHL, seasonal service",
        description: "Watertown International Airport serves Jefferson County with American Airlines flights to Philadelphia. While ART is primarily a domestic airport, it connects North Country travelers to international gateways. Many Watertown residents drive to Syracuse Hancock (SYR, 75 miles) for international departures. The limited flight options mean travelers often plan domestic connector flights weeks in advance — but forget to check passport validity for the international leg.",
        tip: "A domestic connecting flight from ART to PHL does not require a passport, but your final international destination does. Always verify passport validity when booking connecting international itineraries through Philadelphia or other hubs.",
      },
      {
        icon: "ri-global-line",
        title: "Cross-Border Canada Travel & Thousand Islands",
        subtitle: "Canada is 30 miles away — passport needs are constant",
        description: "Watertown's proximity to Canada is unmatched among large upstate New York cities. The Thousand Islands Bridge at Alexandria Bay is 30 miles away, and Montreal is a 3-hour drive. Weekend trips to Ottawa, day cruises on the St. Lawrence River that cross into Canadian waters, and holiday visits to Montreal create constant passport demand. Many Watertown residents remember pre-2009 border crossing rules (when a driver's license sufficed) and discover their passport is expired only when planning a trip.",
        tip: "A Passport Card ($30) is the most cost-effective document for Watertown residents who drive to Canada regularly. It fits in your wallet and is valid for land and sea crossings — perfect for Montreal weekend trips and Thousand Islands cruises.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "SUNY & North Country College Study Abroad",
        subtitle: "SUNY Jefferson, SUNY Potsdam, Clarkson, St. Lawrence University",
        description: "The North Country is home to a cluster of colleges that send hundreds of students abroad each year. SUNY Jefferson in Watertown, SUNY Potsdam (75 miles), Clarkson University (80 miles), and St. Lawrence University (85 miles) all have active study abroad programs. Many of these students are first-generation college students who have never held passports. The 6–8 week window between acceptance and program departure requires expedited processing. First-time passport applicants must also navigate the acceptance clerk visit — confusing for students away from home.",
        tip: "College students applying for first-time passports can visit the Watertown Post Office or Fort Drum Post Office for their acceptance clerk appointment. We guide students through the correct forms and ensure parental consent documentation is complete.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Watertown & the Canadian Border: A Daily Reality",
      description: "Watertown is the largest U.S. city within 30 miles of the Canadian border. The Thousand Islands International Bridge, Ogdensburg-Prescott Bridge, and Massena-Cornwall crossing are all within a short drive. For Watertown residents, Canada is not a foreign country — it is the nearest major city for shopping, culture, and healthcare. This creates a uniquely high passport and passport card demand that is unlike any other city in the project.",
    },
  },
  destinations: {
    title: "Where Watertown Travelers Go — And Why Passports Get Urgent",
    intro: "Watertown's military, border, and academic mix means travelers need passports for destinations tied to deployment, Canadian proximity, and study abroad programs.",
    stats: [
      { stat: "41%", label: "of Watertown expedited requests are military-related with deployment notice windows" },
      { stat: "5–10 Days", label: "typical notice window for Fort Drum PCS and TDY assignments requiring passports" },
      { stat: "May–Aug", label: "peak season when Thousand Islands tourism, military summer moves, and study abroad collide" },
      { stat: "48 Hours", label: "shortest turnaround for a Fort Drum family with PCS orders to Germany — 4 passports processed" },
    ],
    destinations: [
      { name: "Canada", context: "Montreal weekend trips, Ottawa day trips, Thousand Islands cruises, Kingston and Toronto getaways — 30 miles to the border", urgency: "Summer tourism peak May through September — 61% of expedited requests involve Canada", icon: "ri-map-pin-2-line" },
      { name: "Germany", context: "Fort Drum PCS to Wiesbaden, Stuttgart, Grafenwoehr — 10th Mountain Division's most common European assignment", urgency: "PCS orders with 5–10 day notice — the tightest window in the project", icon: "ri-map-pin-2-line" },
      { name: "Italy", context: "Fort Drum PCS to Vicenza, family heritage travel, college study abroad programs in Rome, Florence, and Milan", urgency: "Military orders and fall semester abroad deadlines create overlapping demand", icon: "ri-map-pin-2-line" },
      { name: "South Korea", context: "Fort Drum PCS to Camp Humphreys, Yongsan, Daegu — Pacific theater assignments for 10th Mountain support units", urgency: "Deployment orders with 7–14 day notice and 6-month passport validity requirements", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Mexico", context: "Winter escapes from brutal North Country winters, cruise departures from New York and Florida ports, family resort vacations", urgency: "Snowbird bookings peak January through March during the worst of winter", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom & Ireland", context: "Heritage travel, SUNY Potsdam and St. Lawrence University study abroad, military TDY to RAF bases", urgency: "Fall semester abroad deadlines and summer heritage travel peak", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other New York Service Areas",
    crossLinksDesc: "We serve travelers across the Empire State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Syracuse", route: "/cities/syracuse" },
      { name: "Plattsburgh", route: "/cities/plattsburgh" },
      { name: "Ogdensburg", route: "/cities/ogdensburg" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Watertown", address: "1125 Arsenal Street, Watertown, NY 13601", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Watertown", address: "455 State Street, Watertown, NY 13601", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "Rite Aid — Watertown", address: "1222 Arsenal Street, Watertown, NY 13601", hours: "Call for hours", website: "https://www.riteaid.com/" },
    { name: "Walmart Photo Center — Watertown", address: "20823 NY-3, Watertown, NY 13601", hours: "Daily 8 AM – 10 PM", website: "https://www.walmart.com/photo" },
    { name: "CVS Pharmacy — Carthage", address: "728 West Street, Carthage, NY 13619", hours: "Daily 7 AM – 10 PM", website: "https://www.cvs.com/photo" },
    { name: "The UPS Store — Watertown", address: "1259 Arsenal Street, Watertown, NY 13601", hours: "Call for hours", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "Adams Pharmacy", address: "1 East Church Street, Adams, NY 13605", hours: "Mon–Fri 9 AM – 6 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Carthage", address: "401 State Street, Carthage, NY 13619", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Watertown",
      address: "1001 Coffeen Street, Watertown, NY 13601",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment recommended for Watertown and Jefferson County residents.",
      featured: true,
    },
    {
      name: "NYS DMV — Lowville",
      address: "7588 South State Street, Lowville, NY 13367",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Serving eastern Jefferson County and Lewis County residents. Alternative when Watertown DMV is booked.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ART",
      name: "Watertown International Airport",
      distance: "6 miles from downtown Watertown",
      address: "2380 County Route 66, Dexter, NY 13634",
      note: "Regional airport with American Airlines service to Philadelphia. Primary airport for Jefferson County travelers connecting to international gateways.",
      flightUrl: "https://www.watertownairport.com/",
      flightLabel: "ART Airport Website",
      featured: true,
    },
    {
      code: "SYR",
      name: "Syracuse Hancock International Airport",
      distance: "75 miles from Watertown",
      address: "1000 Col Eileen Collins Blvd, Syracuse, NY 13212",
      note: "Major upstate New York airport with flights to major U.S. hubs and seasonal international destinations. Most Watertown travelers use SYR for international departures.",
      flightUrl: "https://www.syrairport.org/",
      flightLabel: "Syracuse Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the New York State Department of Health Vital Records in Albany. Online, mail, or in-person options available.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through NYS DOH Vital Statistics. Required for estate and legal matters in Jefferson County.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Jefferson County Clerk. Certified copies available for name changes and legal purposes.",
      url: "https://www.jeffersoncountyny.gov/departments/county-clerk/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Jefferson County Supreme Court. Required for name change passport corrections.",
      url: "https://www.nycourts.gov/courts/5jd/jefferson/",
    },
  ],
};

export default watertownConfig;